import { createTheme } from '@material-ui/core/styles'

export const themeDefault = createTheme({
  overrides: {
    MuiPaper: {
      root: {
        width: '100%',
        padding: '0',
        display: 'inline',
        color: 'rgba(0, 0, 0, 1)',
      },
    },
    MuiCardContent: {
      root: {
        padding: '0',
        '&:last-child': {
          paddingBottom: '0',
        },
      },
    },
  },
})

export const tabTheme = createTheme({
  overrides: {
    MuiPaper: {
      root: {
        width: '100%',
        padding: 0,
        display: 'inline',
      },
    },
    MuiCardContent: {
      root: {
        padding: '0',
        paddingTop: '0.5rem',
        '&:last-child': {
          paddingBottom: '0',
        },
      },
    },
  },
})

export const modalDefault = createTheme({
  overrides: {
    MuiPaper: {
      root: {
        width: '100%',
        display: 'inline',
      },
    },
    MuiCardContent: {
      root: {
        paddingTop: '0.5rem',
        padding: '0',
        '&:last-child': {
          paddingBottom: '0',
        },
      },
    },
    MuiGrid: {
      root: {
        width: '100%',
        '& [class*="MuiGrid-container-"]': {
          flexDirection: 'row !important',
        },
        '& [class*="MuiGrid-item-"]': {
          width: '100%',
          display: 'contents',
        },
      },
      item: {
        width: '100%',
        display: 'contents',
      },
      container: {
        flexDirection: 'row !important',
      },
    },
  },
})
